var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown',{attrs:{"dropdown-items":_vm.scores,"selected-name":_vm.getSelectedScore(),"placeholder":'Select score',"on-select":_vm.handleSelectChange}})}
var staticRenderFns = []

export { render, staticRenderFns }